import { Component, Input, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { FacetFilter } from '../pharma-page.model';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-advanced-filters',
  templateUrl: './advanced-filters.component.html',
  styleUrls: ['./advanced-filters.component.scss']
})
export class AdvancedFiltersComponent {
  @Input() loading: boolean;
  @Input() advancedFilterPanels = {} as any;
  @Input() activePanel = "";
  @Input() facetCategorySearch = {} as any;
  @Input() refreshCurrentPanel = false;
  @Input() facetData = {} as any;
  @Input() cachedSelections = {} as any;
  @Input() facetFilter ={} as any;
  @Input() placeholderValues = {} as any; 
  // @Input() lastFacetFilter
  @Output() onKeyUp: EventEmitter<any> = new EventEmitter();
  @Output() onAdvancedFilterChange: EventEmitter<any> = new EventEmitter();
  @Output() onCheckboxOptionChange: EventEmitter<any> = new EventEmitter();
  @Output() onTreePanelExpandChange: EventEmitter<any> = new EventEmitter();
  @Output() onTreePanelHierarchyOptionChange: EventEmitter<any> = new EventEmitter();
  @Output() updateGraph: EventEmitter<any> = new EventEmitter();

  // @ViewChild('peakSalesTemplate') peakSalesTemplate:TemplateRef<any>;
  // @ViewChild('drugRevenueTemplate') drugRevenueTemplate:TemplateRef<any>;
  // @ViewChild('expiry_dateTemplate') expiry_dateTemplate:TemplateRef<any>;
  // @ViewChild('approval_dateTemplate') approval_dateTemplate:TemplateRef<any>;

  // @Input() data = {} as any;
  
  // _advancedFilterPanels = {} as any;
  
  _activePanel = "";
  // _refreshCurrentPanel = false;
  // _facetData = {} as any;
  _cachedSelections = {} as any;
  _facetFilter ={};
  // _lastFacetFilter;

  constructor(private appService: AppService) {}

  ngOnChanges(changes) {
    console.log(this.facetData);
    // this._advancedFilterPanels = {...this.advancedFilterPanels};
    
    this._activePanel= this.activePanel;
    // this._refreshCurrentPanel = this.refreshCurrentPanel;
    // this._facetData = {...this.facetData};
    this._cachedSelections = {...this.cachedSelections};
    this._facetFilter = Object.assign(new FacetFilter(), this.facetFilter) //structuredClone(this.facetFilter);//  {...this.facetFilter};
    // this._lastFacetFilter = this.lastFacetFilter;
  }

  onActiveChange() {}

  formatAmount(val) {
    return this.appService.addThousandsSeparator(Math.abs(val), 0);
  }
  onOptionChange(payload) {
    this.onCheckboxOptionChange.emit(payload)
  }

  onTreeExpandChange(obj) {
    this.onTreePanelExpandChange.emit(obj);
  }

  onTreeHierarchyOptionChange(obj) {
    this.onTreePanelHierarchyOptionChange.emit(obj);
  }

  onUpdateGraph(payload) {
    this.updateGraph.emit(payload)
  }
  onFacetCategorySearch(panel) {
    this.onKeyUp.emit(panel);
  }
  onFilterChange(category, payload) {
    // let {category, option} = obj;
    let _payload = {...payload};
    this._activePanel = category;
    this._cachedSelections = JSON.parse(
      JSON.stringify({ ...this._cachedSelections, [category]: _payload }),
    );
    this._facetFilter[category] = _payload;

    if (!this._cachedSelections[`${category}_data`]) {
      this._cachedSelections[`${category}_data`] = {};
    }

    this._cachedSelections[`${category}_data`] = {
      ...this._cachedSelections[`${category}_data`],
      ..._payload,
    };

    this.onAdvancedFilterChange.emit({
      activePanel: this._activePanel,
      cachedSelections: this._cachedSelections,
      facetFilter: this._facetFilter,
      category
    });
  }
  onSliderFilterChange(category, payload) {
    let payloadData = {...(this.facetFilter as any)[category]};
    payloadData.selected_min = payload.min;
    payloadData.selected_max = payload.max;
    this.onFilterChange(category, payloadData);
  }
  onLaunchYearChange(category, payload) {
    let payloadData = {...(this.facetFilter as any)[category]};
    payloadData.selected_min = payload.min;
    payloadData.selected_max = payload.max;
    this.onFilterChange(category, payloadData);
  }
}
